<template>
  <iframe
    v-if="isShow"
    :class="[$style.embededViewerIframe]"
    :src="readerLaunchUrl"
    frameborder="0"
    allowfullscreen=""
    data-embeded-hybrid-viewer
  ></iframe>
</template>

<script>
import qs from "qs";

export default {
  name: "vc-share-hybrid-viewer",
  data: function() {
    return {
      contentsIdentificationCode: null,
      positionIndex: 1,
      readerLaunchUrl: null,
      isShow: this.isHybrid
    };
  },
  props: {
    isWallPage: {
      type: Boolean,
      default: false
    },
    wallIdentificationCode: {
      type: String,
      default: null
    },
    viewerUrl: {
      type: String,
      default: ""
    },
    hybridReaderFixedUrl: {
      type: String,
      default: ""
    },
    isHybrid: {
      type: Boolean,
      default: false
    },
    isPreview: {
      type: Boolean,
      default: false
    },
    isInitialStartup: {
      type: Boolean,
      default: false
    },
    initialContentsIdentificationCode: {
      type: String,
      default: ""
    },
    getHybridViewerReaderLaunchUrl: {
      type: Function,
      default: async () => {}
    }
  },
  mounted: function() {
    if (this.isInitialStartup) {
      this.isShow = true;
      this.readerLaunchUrl = this.hybridReaderFixedUrl;
    }

    // onMessage用イベントリスナを設定
    const thisObj = this;
    window.addEventListener("message", function(event) {
      if (event.data.event === "launch2dViewer") {
        thisObj.contentsIdentificationCode = event.data.identification_code;
        thisObj.positionIndex = event.data.position_index;

        if (thisObj.isPreview) {
          thisObj.isShow = true;
          thisObj.readerLaunchUrl = thisObj.hybridReaderFixedUrl;
          return;
        }

        const requestData = {
          code: thisObj.contentsIdentificationCode,
          positionIndex: thisObj.positionIndex,
          isWallPage: Number(thisObj.isWallPage)
        };

        thisObj.getHybridViewerReaderLaunchUrl(requestData).then(response => {
          if (response.status === 0) {
            thisObj.readerLaunchUrl = response.data.readerLaunchUrl;
            thisObj.isShow = true;

            let urlParameters = {};
            if (thisObj.wallIdentificationCode) {
              urlParameters["code"] = thisObj.wallIdentificationCode;
            }
            if (!thisObj.isWallPage) {
              urlParameters["code"] = thisObj.contentsIdentificationCode;
            }

            urlParameters["contentsIdentificationCode"] =
              thisObj.contentsIdentificationCode;
            urlParameters["positionIndex"] = thisObj.positionIndex;
            urlParameters["show2dViewer"] = 1;

            const display2dViewerUrlBase = location.origin + location.pathname;
            const display2dViewerUrl =
              display2dViewerUrlBase + "?" + qs.stringify(urlParameters);

            history.replaceState(null, null, display2dViewerUrl);
          }
        });
      }

      if (event.data.event === "close2dViewer") {
        if (!event.data.isColophon) {
          const embeddedViewerIframeElement = document.querySelector(
            "[data-embeded-viewer]"
          ).contentWindow;
          embeddedViewerIframeElement.postMessage(
            "forceReloadBookmark",
            thisObj.viewerUrl
          );
        }

        if (thisObj.isPreview) {
          thisObj.isShow = false;
          return;
        }

        let urlParameters = {};
        if (thisObj.wallIdentificationCode) {
          urlParameters["code"] = thisObj.wallIdentificationCode;
        }
        if (thisObj.initialContentsIdentificationCode) {
          urlParameters["code"] = thisObj.initialContentsIdentificationCode;
        }
        let display2dViewerUrl = location.origin + location.pathname;
        if (Object.keys(urlParameters).length !== 0) {
          display2dViewerUrl += "?" + qs.stringify(urlParameters);
        }
        history.replaceState(null, null, display2dViewerUrl);

        thisObj.isShow = false;
      }

      if (event.data === "backToWallOn2dViewer") {
        let urlParameters = {};
        if (thisObj.wallIdentificationCode) {
          urlParameters["code"] = thisObj.wallIdentificationCode;
        }
        let display2dViewerUrl = location.origin + location.pathname;
        if (Object.keys(urlParameters).length !== 0) {
          display2dViewerUrl += "?" + qs.stringify(urlParameters);
        }
        history.replaceState(null, null, display2dViewerUrl);

        const embeddedViewerIframeElement = document.querySelector(
          "[data-embeded-viewer]"
        ).contentWindow;
        embeddedViewerIframeElement.postMessage(
          "closeCurrentContent",
          thisObj.viewerUrl
        );

        thisObj.isShow = false;
      }
    });
  },
  methods: {
    resizeIframeHeight() {
      let iframeElement = document.querySelector(
        "[data-embeded-hybrid-viewer]"
      );
      let clientHeight = document.getElementById("body").clientHeight;
      iframeElement.style.height = clientHeight + "px";
    }
  },
  watch: {
    isShow() {
      if (this.isShow) {
        this.$nextTick(() => {
          this.resizeIframeHeight();
        });
        window.addEventListener("resize", this.resizeIframeHeight);
      }
    }
  }
};
</script>

<style module>
.embededViewerIframe {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
}
</style>
